export const MAX_EDITORS_TO_SHOW = 3
export const FORM_TYPE_NEW = 'new'
export const FORM_TYPE_EDIT = 'edit'
